import axios from 'axios'
import { handleAxiosPromise, apiConfig } from '@/utils/api-common'

const BASE_URL = process.env.BOOLEAN2D_SERVER
const url = `${BASE_URL}/api/external-user`

export { getUserDetails, createUserDetails, setHasSeenTour, setAttribute, setAttributes }

function setHasSeenTour () {
  return setAttribute('hasSeenTour', true)
}

function setAttribute (attribute, value) {
  const o = {}
  o[attribute] = value
  return handleAxiosPromise(axios.put(url, o, apiConfig()))
}

function setAttributes (attributes) {
  return handleAxiosPromise(axios.put(url, attributes, apiConfig()))
}

function getUserDetails () {
  return handleAxiosPromise(axios.get(url, apiConfig()))
}

function createUserDetails () {
  return handleAxiosPromise(axios.post(
    url,
    { hasSeenTour: false, addQuotesAroundPhrases: true },
    apiConfig()
  ))
}



// WEBPACK FOOTER //
// ./src/utils/users-api.js